import { useEffect } from "react";

export const useChatZoomLock = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof document === "undefined") return undefined;

    document.body.classList.add("chat-zoom-fix");

    return () => {
      document.body.classList.remove("chat-zoom-fix");
    };
  }, [enabled]);
};

export default useChatZoomLock;
